import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';
import { calculateNIRControlKey } from '@Common/validators/nirValidation';

/**
 * Simple NIR format validation - exactly 15 digits
 * Cross-field validation (gender, date consistency) handled at form level
 */
export const ZodNIR = ZodTrimmedString.refine(
  (nir: string) => {
    return /^\d{5}(?:\d{2}|2[AB])\d{8}$/.test(nir);
  },
  {
    message: 'format_invalid',
  },
);

/**
 * Simple NIR format validation - exactly 13 or 15 digits
 * Output is always 15 digits
 * If only 13 digits are provided it calculates the control key and outputs 15 digits
 * Cross-field validation (gender, date consistency) handled at form level
 */
export const ZodNIR13 = ZodTrimmedString.refine(
  // ^\d{5}              -> First 5 digits (Sex, Year, Month)
  // (?:\d{2}|2[AB])     -> Department (2 digits OR 2A/2B for Corsica)
  // \d{6}               -> Commune (3) and Order (3)
  // (\d{2})?            -> Optional Control Key (2 digits)
  (nir) => /^\d{5}(?:\d{2}|2[AB])\d{6}(\d{2})?$/.test(nir),
  { message: 'format_invalid' },
)
  .transform((nir) => {
    if (nir.length === 13) {
      const controlKey = calculateNIRControlKey(nir);
      return `${nir}${controlKey}`;
    }

    return nir;
  })
  .meta({ override: { type: 'string' } });
